import React, { Component } from 'react'
import { apiDashboard } from 'helpers/decorators/api'
import EditProfileInner from './EditProfileInner'

@apiDashboard.apiPersons({
    loadProfile: true,
    isAssessor: true,
})
class EditProfileAssessor extends Component {
  render() {
    return (
      <EditProfileInner {...this.props} />
    )
  }
}

export default EditProfileAssessor
